import React from 'react'
import { Filter as RaFilter } from 'react-admin'

const Filter = props => {
  return <RaFilter {...props} />
}

export default Filter
